import React, { useState } from 'react';
import { DateTime } from 'luxon';
import { SwapFlowModalButtonTypes, SwapFlowModalContentTypes } from './SwapFlowModalTypes';
import { SwapPageFooterContinueButton } from '../../SwapPageFooter/SwapPageFooterContinueButton';
import { SwapTermsModalContentFeature } from '../SwapTermsModalContent';
import { SwapRequestListFeature } from '../SwapRequestList/SwapRequestListFeature';
import { SwapConfirmationModalContent } from '../SwapConfirmationModalContent';
import { CreateSwapRequestError } from '../CreateSwapRequestError';
import { useLocation, useNavigate, useSearchParams } from '../../../hooks';
import { useApolloClient } from '@apollo/client';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { getSwapsRefetchQuery } from '../../../utils';
export function useSwapFlowModal(_a) {
    var initialModalContent = _a.initialModalContent, selectedSwappableDay = _a.selectedSwappableDay, siteSwapConfiguration = _a.siteSwapConfiguration, originalShift = _a.originalShift, employeeId = _a.employeeId, allScheduleDaysForDay = _a.allScheduleDaysForDay;
    var selectedDay = DateTime.fromISO(selectedSwappableDay.date);
    var client = useApolloClient();
    var pathname = useLocation().pathname;
    var searchParams = useSearchParams()[0];
    var fromPath = searchParams.get('source');
    var _b = useState(null), modalError = _b[0], setModalError = _b[1];
    var _c = useState(initialModalContent), modalContent = _c[0], setModalContent = _c[1];
    var _d = React.useState([selectedDay]), currentSelectedDays = _d[0], setCurrentSelectedDays = _d[1];
    var navigate = useNavigate();
    var handleOnClose = function () {
        // If user is on native, then go back to the native schedule page
        // This code is no longer needed once Swap page has been converted to a native app
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var atozmobile = window.atozmobile;
        // this fromPath.includes is needed because for some reason,
        // non-hq webview users cannot go back to the dashboard page
        // using popToTop()
        if (atozmobile && fromPath.includes(Routes.MySchedule)) {
            atozmobile.appNavigation.popToTop();
            return;
        }
        else {
            client.refetchQueries({
                include: getSwapsRefetchQuery(pathname)
            });
            var indexRoute = originalShift.date
                ? "".concat(Routes.Index, "?date=").concat(originalShift.date)
                : Routes.Index;
            navigate(indexRoute);
        }
    };
    var modalButtonMap = function (open) {
        var _a;
        return (_a = {},
            _a[SwapFlowModalButtonTypes.continue] = (React.createElement(SwapPageFooterContinueButton, { buttonId: "requestSwapConfirmation", onClick: function () {
                    setModalContent(SwapFlowModalContentTypes.request);
                    open();
                } })),
            _a);
    };
    var modalContentMap = function (close) {
        var _a;
        return (_a = {},
            _a[SwapFlowModalContentTypes.request] = (React.createElement(SwapRequestListFeature, { close: function () {
                    setCurrentSelectedDays([selectedDay]);
                    close();
                }, setModalContent: setModalContent, originalShift: originalShift, currentSelectedDays: currentSelectedDays, setCurrentSelectedDays: setCurrentSelectedDays, allScheduleDaysForDay: allScheduleDaysForDay, siteSwapConfiguration: siteSwapConfiguration })),
            _a[SwapFlowModalContentTypes.terms] = (React.createElement(SwapTermsModalContentFeature, { close: function () {
                    setCurrentSelectedDays([selectedDay]);
                    close();
                }, setModalError: setModalError, originalShift: originalShift, currentSelectedDays: currentSelectedDays, siteSwapConfiguration: siteSwapConfiguration, setModalContent: setModalContent, employeeId: employeeId, allScheduleDaysForDay: allScheduleDaysForDay })),
            _a[SwapFlowModalContentTypes.swapCreateSuccess] = (React.createElement(SwapConfirmationModalContent, { allScheduleDaysForDay: allScheduleDaysForDay, close: handleOnClose })),
            _a[SwapFlowModalContentTypes.swapCreateError] = (React.createElement(CreateSwapRequestError, { error: modalError, close: handleOnClose })),
            _a);
    };
    return {
        modalButtonMap: modalButtonMap,
        modalContentMap: modalContentMap,
        modalContent: modalContent
    };
}
